export default "__VITE_ASSET__DFuqFG9X__"